import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useRef } from 'react';
import { AutoComplete, message } from 'antd';
import maplibregl from 'maplibre-gl';
import 'maplibre-gl/dist/maplibre-gl.css';
import Button from '../../../components/common/Button';
import { SiteAddressWrapper, SiteAddressMap, SiteOnBoardCardBolck, StepItemRow, StepItemRowInner, StepItemRowHeader, StepItemRowContent, } from '../SiteOnboard.style';
const Step4SiteLocation = ({ onBack, onContinue, loading, onAddressSelect, optionsAddress, onSearch, }) => {
    const mapContainer = useRef(null);
    const map = useRef(null);
    const marker = useRef(null);
    useEffect(() => {
        if (mapContainer.current && !map.current) {
            map.current = new maplibregl.Map({
                container: mapContainer.current,
                style: 'https://beco-lightning-backend.s3.ap-southeast-1.amazonaws.com/styles/style.json',
                center: [0, 0],
                zoom: 2,
                attributionControl: false,
            });
            return () => {
                if (map.current) {
                    map.current.remove();
                }
            };
        }
    }, []);
    const handleAddressSelect = async (value) => {
        try {
            // Find the selected option from the dropdown
            const selectedOption = optionsAddress.find(option => option.value === value);
            if (selectedOption && selectedOption.data) {
                // Use the stored location data
                const location = selectedOption.data;
                onAddressSelect(location);
                if (map.current) {
                    map.current.flyTo({
                        center: [location.lon, location.lat],
                        zoom: 17,
                        speed: 1.5,
                        curve: 1.42,
                        essential: true,
                    });
                    if (!marker.current) {
                        marker.current = new maplibregl.Marker()
                            .setLngLat([location.lon, location.lat])
                            .addTo(map.current);
                    }
                    else {
                        marker.current.setLngLat([location.lon, location.lat]);
                    }
                }
            }
            else {
                message.error('Selected address not found in search results.');
            }
        }
        catch (error) {
            console.error('Error handling address selection:', error);
            message.error('An error occurred while selecting the location.');
        }
    };
    return (_jsxs(_Fragment, { children: [_jsx("div", { style: { flex: 1 }, children: _jsx(SiteOnBoardCardBolck, { className: "no-divider", style: { padding: '0px', overflow: 'hidden' }, children: _jsx(StepItemRow, { children: _jsx(StepItemRowInner, { children: _jsxs(SiteAddressWrapper, { children: [_jsx(SiteAddressMap, { ref: mapContainer }), _jsx("div", { className: "selct-wrapper", children: _jsx(AutoComplete, { variant: "filled", showSearch: true, placeholder: "Search for an address", onSearch: onSearch, onSelect: handleAddressSelect, options: optionsAddress, filterOption: false, style: { width: '100%' } }) })] }) }) }) }) }), _jsx(SiteOnBoardCardBolck, { children: _jsx(StepItemRow, { children: _jsxs(StepItemRowInner, { children: [_jsx(StepItemRowHeader, { children: _jsx(Button, { variant: "solid", color: "gray", onClick: onBack, children: "Back" }) }), _jsx(StepItemRowContent, { style: { textAlign: 'end' }, children: _jsx(Button, { style: { minWidth: '120px' }, color: "primary", variant: "solid", onClick: onContinue, loading: loading, children: "Continue" }) })] }) }) })] }));
};
export default Step4SiteLocation;
